import { find } from 'lodash'
import * as React from 'react'

import sitesConfig from '../../../../config/sites'
import { IItem } from '../../../../typings/searchResults'
import { ISeoItem } from '../../../../typings/seoMetadata'
import Button from '../../../components/button'
import ItemPreviewer from '../../../components/itemPreviewer'
import ItemThumbnailCarousel from '../itemThumbnailCarousel'
import SectionDescription from '../sectionDescription'

import * as styles from './freeItemSection.module.css'

const FreeItemSection = ({
  items,
  metadata,
  isSignedIn,
  videoMuted,
  muteVideo
}: {
  items: IItem[]
  metadata: ISeoItem
  isSignedIn: boolean
  videoMuted: boolean
  muteVideo: () => any
}) => {
  return (
    <div data-test-selector="freeItemSection">
      <SectionDescription metadata={metadata} HTag="h6" />
      <ItemThumbnailCarousel>
        {items.map(item => {
          const siteConfig =
            item.site &&
            find(sitesConfig, config => config.domain === item.site)
          const siteName = siteConfig && siteConfig.name

          return (
            <ItemPreviewer
              item={item}
              key={item.id}
              annotation={siteName}
              videoMuted={videoMuted}
              muteVideo={muteVideo}
            />
          )
        })}
      </ItemThumbnailCarousel>
      {!isSignedIn && (
        <div className={styles.buttonSection}>
          <Button primary href="/sign_up">
            Sign Up
          </Button>
        </div>
      )}
    </div>
  )
}

export default FreeItemSection



// WEBPACK FOOTER //
// ./client/pages/home/freeItemSection/freeItemSection.tsx